module.exports = __webpack_public_path__ + "static/GminaMiastaOlesnica-a24e1e031befa444dbbaf2dad286f8f2.svg";